module.exports = __webpack_public_path__ + "media/assets/images/prescrittivo-fef87a997b5b4fa9f3da22c4021aaeb0.png";